import * as userStore from '../stores/userStore';
import { trackMetricsEvent } from './trackMetricsEvent';

export type SeenOutcome = 'completed' | 'dismissed' | 'started';

export type WizardSeenProperties = {
  /** Matches wizardsStarted keys, e.g. CANVAS_ON_OPEN, MOTION_EDITOR_ON_MOTION */
  wizardType: string;
  outcome: SeenOutcome;
  /** Highest step number reached when dismissed. Omit when completed. */
  lastStepSeen?: number;
};

export type TrackWizardSeenOptions = {
  eventSource: string;
  app?: string;
} & WizardSeenProperties;

/**
 * Fire-and-forget UI emit for Metrics `wizardSeen`.
 * Failures are ignored so tour UX is never blocked by analytics.
 */
export function trackWizardSeen({
  eventSource,
  app,
  wizardType,
  outcome,
  lastStepSeen,
}: TrackWizardSeenOptions): void {
  const properties: WizardSeenProperties = {
    wizardType,
    outcome,
  };
  if (lastStepSeen !== undefined) {
    properties.lastStepSeen = lastStepSeen;
  }

  const userID = userStore.state.userInfo.userID?.trim() || undefined;

  void trackMetricsEvent({
    eventName: 'wizardSeen',
    eventSource,
    ...(app ? { app } : {}),
    ...(userID ? { createdByUserID: userID } : {}),
    properties,
  });
}
